import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=4b9dc7a0"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports